import { useStytchMember } from "@stytch/react/b2b";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { member } = useStytchMember();

  if (!member) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
